import { create } from 'zustand';
import { produce } from 'immer';
const initialState = {
    projects: [],
};
export const useProjectsStore = create((set, get) => ({
    ...initialState,
    setProjects: (projects) => set({ projects }),
    addProject: (project) => set(produce((state) => {
        state.projects.push(project);
        state.projects.sort((a, b) => a.name.localeCompare(b.name));
    })),
    removeProject: (projectId) => set(produce((state) => {
        const idx = state.projects.findIndex((x) => x.id === projectId);
        if (idx !== -1) {
            state.projects.splice(idx, 1);
        }
    })),
    updateProject: (project) => set(produce((state) => {
        const idx = state.projects.findIndex((x) => x.id === project.id);
        if (idx !== -1) {
            state.projects[idx] = project;
        }
    })),
    reset: () => set(initialState),
}));
export const selectProjectById = (state, projectId) => state.projects.find((project) => project.id === projectId);
